<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Vehicle Deails</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button size="sm" variant="warning" @click="goToMain"
                >New Vehicle</b-button
              >
              <!-- <b-button
                size="sm"
                class="ml-3"
                @click="getReportsAss('All_VehicleMaster_Report')"
                variant="outline-info"
                >Export as Excel</b-button
              > -->

              <b-button
                :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                class="ml-2"
                type="submit"
                @click="getReportsAss('All_VehicleMaster_Report', 'Export as Excel')"
                size="sm"
                variant="primary"
                >{{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>

              <b-col md="2" class="text-right" v-if="veiwVehicleMaster.length > 0">
                <b-button
                  v-if="veiwVehicleMaster.length > 0"
                  class="ml-3"
                  :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                  @click="exportVehiclesDetailsReportDashboard()"
                  size="sm"
                  variant="outline-info"
                >
                  {{ ExcelBtnName }}
                  <b-spinner
                    v-if="ExcelBtnName != 'Export as Excel'"
                    small
                    label="Small Spinner"
                  ></b-spinner>
                </b-button>
              </b-col>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <div>
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small>{{ totalRows }} Entries</small>
          </h5>
        </div>
        <!-- User Interface controls -->
        <div>
          <b-row>
            <b-col md="8">
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="filter"
                    placeholder="Type to Search"
                  />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="2" class="my-1">
              <model-list-select
                @input="viewTypeSize"
                :list="StatusList"
                v-model="Status"
                option-value="inv"
                option-text="int"
                placeholder="Select Status"
              ></model-list-select>
            </b-col>
          </b-row>
        </div>
        <div class="table-responsive tableMain mt-3">
          <!-- Main table element -->
          <b-table
            show-empty
            stacked="md"
            :items="veiwVehicleMaster"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template slot="rc_sale_amt" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="regdNo" slot-scope="row1">
              <span
                @click="editVehicleDetail(row1.item.vehicleTruckId)"
                class="showMoreData"
                >{{ row1.item.regdNo }}</span
              >
              <br />
              <h6
                v-if="
                  row1.item.isTruckMasterActive == '1' &&
                  row1.item.vehicleActiveInactiveId == '1'
                "
              >
                <b-badge variant="success">Available</b-badge>
              </h6>
              <h6
                v-if="
                  row1.item.isTruckMasterActive == '0' &&
                  row1.item.vehicleActiveInactiveId == '1'
                "
              >
                <b-badge variant="danger">Booked</b-badge>
              </h6>
              <h6 v-if="row1.item.vehicleActiveInactiveId == '2'">
                <b-badge variant="dark">INACTIVE</b-badge>
              </h6>
            </template>

            <template slot="isTruckMasterActive" slot-scope="row21">
              <div v-if="adminToggle == 'Admin'" :id="'row' + row21.item.vehicleTruckId">
                <md-switch
                  :id="'approval' + row21.item.vehicleTruckId"
                  name="approval"
                  class="md-primary"
                  :value="row21.item.isTruckMasterActive == 1 ? true : false"
                  @change="activateBookVehicle(row21.item)"
                >
                  <h6>
                    <br />
                    <b-badge style="margin-left: -45px">{{
                       (row21.item.isTruckMasterActive == '0' &&
                       row21.item.vehicleActiveInactiveId == '1') ? "Booked" :(row21.item.isTruckMasterActive == '1' &&
                       row21.item.vehicleActiveInactiveId == '1')?"Available": "In-Active"
                    }}</b-badge>
                  </h6>
                </md-switch>
              </div>
              <div v-else :id="'row' + row21.item.vehicleTruckId">
                <h6>
                  <b-badge>{{
                     (row21.item.isTruckMasterActive == '0' &&
                     row21.item.vehicleActiveInactiveId == '1') ? "Booked" : (row21.item.isTruckMasterActive == '1' &&
                     row21.item.vehicleActiveInactiveId == '1')?"Available":"In-Active"
                  }}</b-badge>
                </h6>
              </div>
            </template>
            <template slot="status" slot-scope="row21">
              <div v-if="adminToggle == 'Admin'" :id="'row' + row21.item.vehicleTruckId">
                <md-switch
                  :id="'approval' + row21.item.vehicleTruckId"
                  name="approval"
                  class="md-primary"
                  :value="row21.item.vehicleActiveInactiveId == 1 ? true : false"
                  @change="activateVehicle(row21.item)"
                >
                  <h6>
                    <br />
                    <b-badge style="margin-left: -45px">{{
                      row21.item.vehicleActiveInactiveId == 1 ? "Active" : "In-Active"
                    }}</b-badge>
                  </h6>
                </md-switch>
              </div>
              <div v-else :id="'row' + row21.item.vehicleTruckId">
                <h6>
                  <b-badge>{{
                    row21.item.vehicleActiveInactiveId == 1 ? "Active" : "In-Active"
                  }}</b-badge>
                </h6>
              </div>
            </template>
            <template slot="vehicleTruckId" slot-scope="row">
              <b-button
                variant="outline-info"
                size="sm"
                @click="showDirection(row.item.vehicleTruckId)"
                >Track Vehicle</b-button
              >
            </template>
          </b-table>
        </div>
        <b-row>
          <b-col md="12" class="my-1">
            <b-pagination
              limit="5"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              align="center"
            />
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus, getParseDateYMDFormate } from "../../../helper/collection";
import { read, utils, writeFile } from "xlsx";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/vehicle/viewVehicleDetail/");
      if (globalPermissionStatus("vehicleMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("vehicleMaster")
        );
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }

      this.viewTypeSize();
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },

  data() {
    return {
      fields: [
        {
          key: "rc_sale_amt",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        
        {
          key: "regdNo",
          label: "Vehicle No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "isTruckMasterActive",
          label: "Booking Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vehicleType",
          label: "Vehicle Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "engineNo",
          label: "Engine No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "chassisNo",
          label: "Chassis No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "modNo",
          label: "Modal No",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "driverName",
          label: "Driver Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vehicleTruckId",
          label: "Action",
          sortable: true,
          sortDirection: "desc",
          class: "text-center",
        },

        // {
        //   key: "age",
        //   label: "Person age",
        //   sortable: true,
        //   class: "text-center"
        // },
        // { key: "isActive", label: "is Active" },
        // { key: "actions", label: "Actions" }
      ],
      StatusList: [
        {
          inv: "2",
          int: "All",
        },
        {
          inv: "0",
          int: "Inactive",
        },
        {
          inv: "1",
          int: "Active",
        },
      ],
      Status: "1",
      ExcelBtnName: "Export as Excel",
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      adminToggle: this.$sessionsStorage.get("designation"),
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      excelUpload: "",
      veiwVehicleMaster: [],
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {
    // this.JqueryFun();
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.$router.push({
        path: "/vehicle/truckMaster",
      });
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    JqueryFun() {
      return $(function () {
        return $("#vehicleMas11").DataTable({
          lengthChange: false,
          width: 100,
          dom: '<"wrapper"iftp>',
        });
      });
    },

    editVehicleDetail(vehicleID) {
      //console.log(vehicleID);
      this.$sessionsStorage.set("editVehicleId", vehicleID);
      this.$router.push({
        path: "/vehicle/truckMaster",
      });
    },

    showDirection(vehicleID) {
      //console.log(vehicleID);
      this.$sessionsStorage.set("editVehicleId", vehicleID);
      this.$router.push({
        path: "/map",
      });
    },
    previousSales() {
      this.$router.push({
        path: "/sales/salesBooking",
        // params:{
        //   "userId":res.data.Id,
        // }
      });
    },

    viewTypeSize() {
      this.doLoading();
      let type_Size = {
        truckTypesize: "truckTypesize",
        Status: this.Status,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewTruckMaster.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (data.clientId != "" && status == 200 && data) {
            this.veiwVehicleMaster = data.truckMasterDetails;
            this.totalRows = data.truckMasterDetails.length;
            this.doLoadingClose();
            this.JqueryFun();
            //console.log("fsf",data.truckSizeDetails)
          }
        })
        .catch((error) => {});
    },
    downloadExcel() {
      let excelName = {
        excelName: "VehicleMaster",
        validExcel: "yes",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/downloadMasterExcel.php`,
        data: JSON.stringify(excelName),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // console.log(data);
            // console.log(data.link12);

            window.open(data.link12);
          }
        })
        .catch((error) => {});
    },
    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`vehicleMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then((result) => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.viewTypeSize();
        })
        .catch((err) => {
          throw err;
        });
    },
    // Added By Priyanshu Singh Start
    getReportsAss(id, btnName) {
      this.isLoading = true;
      let excelIdGivin = "";
      if (id == "All_VehicleMaster_Report") {
        excelIdGivin = "All_VehicleMaster_Report";
      }
      let view_AgentColoder = {
        excelId: excelIdGivin,
        assignmentNo: "VehicleMaster",
        searchVal: this.filter,
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      console.log(view_AgentColoder);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getTPTDashreportsExcel.php`,
        data: JSON.stringify(view_AgentColoder),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.ExcelBtnName = btnName;
            if (data.excelName != undefined) {
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    activateVehicle(item, index) {
      let vehicleActiveInactiveId = item.vehicleActiveInactiveId == 1 ? 0 : 1;
      let paylod = {
        tableName: "vehicletruckmaster",
        UpdateId: "vehicleTruckId",
        UpdateStatus_name: "vehicleActiveInactiveId",
        UpdateStatus_val: vehicleActiveInactiveId,
        UpdateIdVal: item.vehicleTruckId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateVehicle.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // this.vehicleSizeMaster[index] = this.itemObj;
            this.viewTypeSize();
          }
        })
        .catch((error) => {});
    },
    activateBookVehicle(item, index) {
      let isTruckMasterActive = item.isTruckMasterActive == 1 ? 0 : 1;
      let paylod = {
        tableName: "vehicletruckmaster",
        UpdateId: "vehicleTruckId",
        UpdateStatus_name: "isTruckMasterActive",
        UpdateStatus_val: isTruckMasterActive,
        UpdateIdVal: item.vehicleTruckId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateVehicle.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // this.vehicleSizeMaster[index] = this.itemObj;
            this.viewTypeSize();
          }
        })
        .catch((error) => {});
    },
    // Added By Priyanshu Singh Start

    exportVehiclesDetailsReportDashboard() {
      if (this.veiwVehicleMaster.length > 0) {
        this.ExcelBtnName = "Downloading....";
        let newSheetdata = [];
        this.veiwVehicleMaster.map((obj, index) => {
          let SN = parseInt(index) + parseInt(1);
          let vehicleNo = obj.vehicleNo;
          let vehicleType = obj.vehicleType;
          let vehicleSize = obj.vehicleSize;
          let regdNo = obj.regdNo;
          let modNo = obj.modNo;
          let engineNo = obj.engineNo;
          let chassisNo = obj.chassisNo;
          let vmodelYear = getParseDateYMDFormate(obj.vmodelYear);
          let driverName = obj.driverName;
          let driverContact = obj.driverContact;
          let nPermit = obj.nPermit;
          let mvTax = obj.mvTax;
          let fitness = obj.fitness;
          let Pollution = obj.Pollution;
          let MU_TAX = obj.MU_TAX;
          let pollutionCertificate = obj.pollutionCertificate;
          let NPAValidity = obj.NPAValidity ? getParseDateYMDFormate((obj.NPAValidity).split(" ")[0]) : "";
          let NPValidity = obj.NPValidity ? getParseDateYMDFormate((obj.NPValidity).split(" ")[0]) : "";
          let FCValidity = obj.FCValidity ? getParseDateYMDFormate((obj.FCValidity).split(" ")[0]) : "";
          let INValidity = obj.INValidity ? getParseDateYMDFormate((obj.INValidity).split(" ")[0]) : "";
          let MUValidity = obj.MUValidity ? getParseDateYMDFormate((obj.MUValidity).split(" ")[0]) : "";
          let polutionValidity = obj.polutionValidity
            ? getParseDateYMDFormate((obj.polutionValidity).split(" ")[0])
            : "";
          let RCValidity = obj.RCValidity ? getParseDateYMDFormate((obj.RCValidity).split(" ")[0]) : "";
          let creationTime = obj.creationTime
            ? getParseDateYMDFormate((obj.creationTime).split(" ")[0])
            : "";
          let updateTime = obj.updateTime ? getParseDateYMDFormate((obj.updateTime).split(" ")[0]) : "";

          let status;
          if (obj.isTruckMasterActive == "0") {
            status = "Inactive";
          } else if (obj.isTruckMasterActive == "1") {
            status = "Active";
          }

          const newData = {
            SN: SN,
            vehicleNo: vehicleNo,
            vehicleType: vehicleType,
            vehicleSize: vehicleSize,
            regdNo: regdNo,
            modNo: modNo,
            engineNo: engineNo,
            chassisNo: chassisNo,
            vmodelYear: vmodelYear,
            driverName: driverName,
            driverContact: driverContact,
            nPermit: nPermit,
            mvTax: mvTax,
            MuTax: MU_TAX,
            fitness: fitness,
            Pollution: Pollution,
            pollutionCertificate: pollutionCertificate,
            NPAValidity: NPAValidity,
            NPValidity: NPValidity,
            FCValidity: FCValidity,
            INValidity: INValidity,
            MUValidity: MUValidity,
            polutionValidity: polutionValidity,
            RCValidity: RCValidity,
            creationTime: creationTime,
            updateTime: updateTime,
            status: status,

            rc_regn_no: obj.rc_regn_no,
            rc_regn_dt: obj.rc_regn_dt ? getParseDateYMDFormate((obj.rc_regn_dt).split(" ")[0]) : "",
            rc_regn_upto: obj.rc_regn_upto ? getParseDateYMDFormate((obj.rc_regn_upto).split(" ")[0]) : "",
            rc_purchase_dt: obj.rc_purchase_dt ? getParseDateYMDFormate((obj.rc_purchase_dt).split(" ")[0]) : "",
            rc_owner_sr: obj.rc_owner_sr,
            rc_owner_name: obj.rc_owner_name,
            rc_f_name: obj.rc_f_name,
            state_cd: obj.state_cd,
            rto_cd: obj.rto_cd,
            rc_present_address: obj.rc_present_address,
            rc_permanent_address: obj.rc_permanent_address,
            rc_vch_catg: obj.rc_vch_catg,
            rc_mobile_no: obj.rc_mobile_no,
            rc_vh_class_desc: obj.rc_vh_class_desc,
            rc_chasi_no: obj.rc_chasi_no,
            rc_eng_no: obj.rc_eng_no,
            rc_maker_desc: obj.rc_maker_desc,
            rc_maker_model: obj.rc_maker_model,
            rc_body_type_desc: obj.rc_body_type_desc,
            rc_fuel_desc: obj.rc_fuel_desc,
            rc_color: obj.rc_color,
            rc_norms_desc: obj.rc_norms_desc,
            rc_fit_upto: obj.rc_fit_upto ? getParseDateYMDFormate((obj.rc_fit_upto).split(" ")[0]) : "",
            rc_np_upto: obj.rc_np_upto ? getParseDateYMDFormate((obj.rc_np_upto).split(" ")[0]) : "",
            rc_np_issued_by: obj.rc_np_issued_by,
            rc_tax_upto: obj.rc_tax_upto ? getParseDateYMDFormate((obj.rc_tax_upto).split(" ")[0]) : "",
            rc_financer: obj.rc_financer,
            rc_insurance_comp: obj.rc_insurance_comp,
            rc_insurance_policy_no: obj.rc_insurance_policy_no,
            rc_insurance_upto: obj.rc_insurance_upto ? getParseDateYMDFormate((obj.rc_insurance_upto).split(" ")[0]) : "",
            rc_manu_month_yr: obj.rc_manu_month_yr,
            rc_unld_wt: obj.rc_unld_wt,
            rc_gvw: obj.rc_gvw,
            rc_no_cyl: obj.rc_no_cyl,
            rc_cubic_cap: obj.rc_cubic_cap,
            rc_seat_cap: obj.rc_seat_cap,
            rc_sleeper_cap: obj.rc_sleeper_cap,
            rc_wheelbase: obj.rc_wheelbase,
            rc_registered_at: obj.rc_registered_at,
            rc_pucc_upto: obj.rc_pucc_upto ? getParseDateYMDFormate((obj.rc_pucc_upto).split(" ")[0]) : "",
            rc_status_as_on: obj.rc_status_as_on ? getParseDateYMDFormate((obj.rc_status_as_on).split(" ")[0]) : "",
            rc_pucc_no: obj.rc_pucc_no,
            rc_status: obj.rc_status,
            rc_permit_no: obj.rc_permit_no,
            rc_permit_issue_dt: obj.rc_permit_issue_dt ? getParseDateYMDFormate((obj.rc_permit_issue_dt).split(" ")[0]) : "",
            rc_permit_valid_from: obj.rc_permit_valid_from ? getParseDateYMDFormate((obj.rc_permit_valid_from).split(" ")[0]) : "",
            rc_permit_valid_upto: obj.rc_permit_valid_upto ? getParseDateYMDFormate((obj.rc_permit_valid_upto).split(" ")[0]) : "",
            rc_permit_type: obj.rc_permit_type,
            rc_permit_code: obj.rc_permit_code,
            rc_vh_class: obj.rc_vh_class,
            rc_fuel_cd: obj.rc_fuel_cd,
            rc_maker_cd: obj.rc_maker_cd,
            rc_norms_cd: obj.rc_norms_cd,
            rc_sale_amt: obj.rc_sale_amt,
            rc_vehicle_surrendered_to_dealer: obj.rc_vehicle_surrendered_to_dealer,
            rc_currentadd_statename: obj.rc_currentadd_statename,
            rc_currentadd_districtcode: obj.rc_currentadd_districtcode,
            rc_currentadd_pincode: obj.rc_currentadd_pincode,
            rc_non_use: obj.rc_non_use,
          };
          newSheetdata.push(newData);
        });
        let fileName = "Vehicles_Details_Master_Report_" + ".xlsx";
        const headings = [
          [
            "SN",
            "Vehicle No.",
            "Vehicle Type",
            "Vehicle Size",
            "REDG No",
            "MOD No.",
            "Engine No.",
            "Chassis No.",
            "Vehicle Model Year",
            "Driver Name",
            "Driver Contact",
            "N Permit",
            "MV Tax",
            "MU Tax",
            "Fitness",
            "Pollution",
            "Pollution Certificate",
            "NPAValidity",
            "NPValidity",
            "FCValidity",
            "INValidity",
            "MUValidity",
            "Polution Validity",
            "RCValidity",
            "Creation Time",
            "Update Time",
            "Active Status",

            "ULIP Registration Number",
            "Registration Date",
            "Registration Valid Upto",
            "Purchase Date",
            "Owner Serial",
            "Owner Name",
            "Father's Name",
            "State Code",
            "RTO Code",
            "Present Address",
            "Permanent Address",
            "Vehicle Category",
            "Mobile Number",
            "Vehicle Class Description",
            "Chassis Number",
            "Engine Number",
            "Maker Description",
            "Maker Model",
            "Body Type Description",
            "Fuel Description",
            "Color",
            "Norms Description",
            "Fitness Valid Upto",
            "NP Valid Upto",
            "NP Issued By",
            "Tax Valid Upto",
            "Financer",
            "Insurance Company",
            "Insurance Policy Number",
            "Insurance Valid Upto",
            "Manufacture Month/Year",
            "Unladen Weight",
            "Gross Vehicle Weight",
            "Number of Cylinders",
            "Cubic Capacity",
            "Seat Capacity",
            "Sleeper Capacity",
            "Wheelbase",
            "Registered At",
            "PUCC Valid Upto",
            "Status As On",
            "PUCC Number",
            "Status",
            "Permit Number",
            "Permit Issue Date",
            "Permit Valid From",
            "Permit Valid Upto",
            "Permit Type",
            "Permit Code",
            "Vehicle Class",
            "Fuel Code",
            "Maker Code",
            "Norms Code",
            "Sale Amount",
            "Vehicle Surrendered to Dealer",
            "Current Address State Name",
            "Current Address District Code",
            "Current Address Pincode",
            "Non-use",
          ],
        ];
        const wb = utils.book_new();
        const ws = utils.json_to_sheet([]);
        utils.sheet_add_aoa(ws, headings);
        utils.sheet_add_json(ws, newSheetdata, { origin: "A2", skipHeader: true });
        utils.book_append_sheet(wb, ws, "Report");
        writeFile(wb, fileName);
        this.ExcelBtnName = "Export as Excel";
      }
    },
  },
};
</script>
<style scoped>
body {
  table-layout: fixed !important;
}
</style>



// WEBPACK FOOTER //
// viewVehicleDetail.vue?32bb6d1e